var React = require('react');

function ThreeDotsHorizontal (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#000","fillRule":"evenodd","opacity":".7"},[React.createElement("circle",{"cx":"2","cy":"2","r":"2","key":0}),React.createElement("circle",{"cx":"10","cy":"2","r":"2","key":1}),React.createElement("circle",{"cx":"18","cy":"2","r":"2","key":2})]));
}

ThreeDotsHorizontal.defaultProps = {"width":"20","height":"4","viewBox":"0 0 20 4"};

module.exports = ThreeDotsHorizontal;

ThreeDotsHorizontal.default = ThreeDotsHorizontal;
